import { DetailedHTMLProps, HTMLAttributes, memo, useMemo } from 'react';
import { components, ControlProps } from 'react-select';

import { ControlledSelectOption } from '../types/ControlledSelectOption';

const ControlComponent = <IsMulti extends boolean = false>({
  children,
  innerProps,
  ...props
}: ControlProps<ControlledSelectOption, IsMulti>) => {
  const innerPropsWithFocus = useMemo(
    () =>
      ({
        ...innerProps,
        'data-focus-visible': props.isFocused ? 'true' : undefined,
      }) as DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    [props.isFocused, innerProps],
  );

  return (
    <components.Control {...props} innerProps={innerPropsWithFocus}>
      {children}
    </components.Control>
  );
};

export const Control = memo(ControlComponent) as typeof ControlComponent;
